/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by jessenelson on 7/17/15.
 */

function ContentSelectModalComponent(
    this: JS5Object,
    $filter: JS5Function,
    $scope: JS5Object,
    uiGridConstants: JS5Object,
    ContentResourceFactory: JS5Object
) {

    //======//
    // Grid //
    //======//

    this.gridOptions = {
        data: [],
        enableHorizontalScrollbar: uiGridConstants.scrollbars.NEVER,
        enableRowHeaderSelection: false,
        enableRowSelection: true,
        enableVerticalScrollbar: uiGridConstants.scrollbars.WHEN_NEEDED || 2,
        multiSelect: false,
        rowSelection: true,
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html',
        columnDefs: [{
            cellTemplate: 'components/modal/content-select-modal/locked-content-cell-template.html',
            enableColumnMenu: false,
            enableFiltering: false,
            field: 'name',
            sort: {
                direction: 'asc',
                priority: 0
            },
        }],
        onRegisterApi: (gridApi: JS5Object) => {
            this.gridApi = gridApi;
            this.gridApi.selection.on.rowSelectionChanged($scope, this.gridRowSelectionHandler);
        },
    };

    this.gridRowSelectionHandler = (row: JS5Object) => {
        if (row.entity.locked && row.isSelected) {
            this.gridApi.selection.unSelectRow(row.entity);
        }
    };

    this.onRowDblClick = (row: JS5Object) => {
        let content: JS5Object = row.entity;
        if(!content.locked) {
            this.close({$value: content});
        }
    };


    //===================//
    // Template Response //
    //===================//

    const getSelectedContent = () => {
        if (!this.gridApi) {
            return undefined;
        }
        return this.gridApi.selection.getSelectedRows()[0];
    };

    this.executeSearch = (searchText: string) => {
        // Case is handled by the filter to make case insensitive searches
        let searchCriteria = {name: searchText};
        this.gridOptions.data = $filter('filter')(this.originalData, searchCriteria);
    };

    this.disableOKButton = () => {
        return !getSelectedContent();
    };

    this.onOK = () => {
        let selectedContent = getSelectedContent();
        this.close({$value: selectedContent});
    };

    this.cancel = () => {
        this.dismiss({$value: 'cancel'});
    };


    //=================//
    // Lifecycle Hooks //
    //=================//

    const executeQuery = () => {
        if (this.resolve.contents) {
            this.gridOptions.data = this.resolve.contents;
            this.originalData = angular.copy(this.resolve.contents);
        } else {
            ContentResourceFactory.query({
                type: this.resolve.contentType,
                fetchLimit: '10000',
                includeHidden: false,
                view: 'MINIMAL'
            }).$promise.then((data: JS5Object) => {
                this.gridOptions.data = data;
                this.originalData = angular.copy(data);
            });
        }
    };

    this.$onInit = () => {
        executeQuery();
    };

}

angular.module('prism-ui.package').component(
    'contentSelectModalComponent',
    {
        bindings: {
            close: '&',
            dismiss: '&',
            resolve: '<'
        },
        controller: ContentSelectModalComponent,
        templateUrl: 'components/modal/content-select-modal/content-select-modal-template.html'
    });
